export enum ClaimStates {
  ORDER_LOOKUP = "ORDER_LOOKUP",
  ORDER_SUMMARY = "ORDER_SUMMARY",
  CHOOSE_CLAIM_REASON = "CHOOSE_CLAIM_REASON",
  SELECT_CLAIM_ITEMS = "SELECT_CLAIM_ITEMS",
  CHOOSE_ISSUE = "CHOOSE_ISSUE",
  CLAIM_CONFIRMATION = "CLAIM_CONFIRMATION",
  CLAIM_SUBMITTED = "CLAIM_SUBMITTED",
  ORDER_TRACKING = "ORDER_TRACKING",
  THANK_YOU = "THANK_YOU",
} 